<template>

    <div class="component-parent"
        :style="getPaddingBottom">
        <!-- 通过 <component :is="..."> 动态渲染对应组件 -->
        <drop-load :on-refresh="getActivityDetailData">
            <component :is="getComponent(item)"
                v-for="(item, index) in componentVOList"
                :key="item.id"
                :activityComponentObj="item"
                :isLoginFlag="isLoginFlag"
                :isFixed="item.type === COMPONENT_TYPE.LOGIN_COMPONENT && index === componentVOList.length - 1"
                :activityCode="activityCode"
                :loginType="loginType"
                :activityUrl="activityUrl"
                :miniNickName="miniNickName"></component>
        </drop-load>
        <div class="component-rules"
            @click="getRules()">
            <img class="rules-image"
                :src="require('../../../../static/image/activityManage/rulesImage.svg')">
            <div class="rules">规则</div>
        </div>
        <van-popup v-model="isShow"
            :closeOnClickOverlay="false"
            class="popup">
            <div class="popup-all">
                <div class="close-image"
                    @click="isShow = false">
                    <img class="image"
                        :src="require('../../../../static/image/activityManage/close.svg')">
                </div>
                <div class="popup-rules">活动规则</div>
                <div class="popup-content"
                    v-html="ruleDesc">
                </div>
            </div>
        </van-popup>
        <!-- 活动未开始、已暂停、已结束弹窗 -->
        <activity-status-dialog ref="activityManagementRef"
            :activityStatus="activityStatus"
            :activityStartDate="activityStartTime"
            :activityEndDate="activityEndTime"></activity-status-dialog>
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>

</template>

<script>
import ImagesComponent from './activityManagementComponents/imagesComponent';
import LoginComponent from './activityManagementComponents/loginComponent';
import TaskComponent from './activityManagementComponents/taskComponent';
import utils from '../../../utils/comUtils.js';
import { IMAGE_SHOW_TYPE, TASK_STATUS, COMPONENT_TYPE, LoginType, ActivityStatus } from '../../../commons/commonVariables.js';
import { config } from '@/api/config.js';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';
import { checkClient } from './common-methods/utils';
import ActivityStatusDialog from './themaicComponent/activity-status-dialog.vue';
import DropLoad from '../../../components/common/drop-load.vue';
// 添加和移除事件的监听方法
const EVENT = {
  // 添加
  addHandler(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      // 兼容ie
      element.attachEvent('on' + type, handler);
    } else {
      element['on' + type] = handler;
    }
  },

  // 移除
  removeHandler(element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false);
    } else if (element.detachEvent) {
      // 兼容ie
      element.detachEvent('on' + type, handler);
    } else {
      element['on' + type] = null;
    }
  },
};
export default {
  components: { ImagesComponent, LoginComponent, TaskComponent, IncorrectClient, ActivityStatusDialog, DropLoad },
  props: {
    activityObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      activityCode: '',
      isLoginFlag: false,
      isShow: false,
      userBase: {},
      loginType: '', //登入类型
      shareType: '',
      userUnionid: '',
      alipayUserId: '',
      componentVOList: [],
      activityUrl: '',
      miniNickName: '',
      ruleDesc: '',
      IMAGE_SHOW_TYPE: IMAGE_SHOW_TYPE,
      TASK_STATUS: TASK_STATUS,
      COMPONENT_TYPE: COMPONENT_TYPE,
      isCorrectClient: true,
      originLoginType: LoginType.None,
      activityStatus: '', // 当前活动状态
      activityStartTime: '',
      activityEndTime: '',
    };
  },
  created() {
    // 初始化用户信息
    const userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
    this.userBase = Object.assign({}, userInfo);
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.shareType = sessionStorage.getItem('shareType') || '';
    this.activityCode = (this.activityObj && this.activityObj.activityCode) || '';
    this.userUnionid = sessionStorage.getItem('userUnionid') || '';
    this.alipayUserId = sessionStorage.getItem('alipayUserId') || '';
    this.miniNickName = userInfo.nickName || '';
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + this.activityCode;
    // 打开方式是微信时，判断是否有登录
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' || sessionStorage.getItem('isLoginFlag') === true ? true : false;
    this.getActivityDetailData();
  },
  mounted() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
    console.log('活动管理-邀请有礼-loginType=====>', this.loginType);
    console.log('活动管理-邀请有礼-isLoginFlag=====>', this.isLoginFlag);
    console.log('活动管理-邀请有礼-isMemberInner=====>', this.isMemberInner);
    console.log('活动管理-邀请有礼-miniProgramFlag=====>', this.miniProgramFlag);
    console.log('活动管理-邀请有礼-envVersion=====>', this.envVersion);
    console.log('活动管理-邀请有礼-activityUrl=====>', this.activityUrl);
    EVENT.addHandler(document, 'visibilitychange', () => {
      if (document.visibilityState == 'visible' && this.isLoginFlag) {
        this.getActivityDetailData();
      }
    });
  },
  destroyed() {
    // 组件销毁时，需要移除页面事件监听
    EVENT.removeHandler(document, 'visibilitychange', () => {});
  },
  computed: {
    getPaddingBottom() {
      if (Array.isArray(this.componentVOList) && this.componentVOList.length > 0) {
        const last = this.componentVOList[this.componentVOList.length - 1];
        if (last.type === this.COMPONENT_TYPE.LOGIN_COMPONENT) {
          return {
            'padding-bottom': 60 + last.jsonField.componentTopMargin + 'px',
          };
        }
      }
      return {
        'padding-bottom': '0px',
      };
    },
  },
  methods: {
    async downloadAndReadTextFile(ruleDescriUrl) {
      console.log('规则url和内容', ruleDescriUrl);
      if (!ruleDescriUrl || ruleDescriUrl == ' ' || ruleDescriUrl == '' || ruleDescriUrl == null || ruleDescriUrl == undefined) {
        // 各种不存在的url情况
        this.ruleDesc = '';
        return;
      }
      // const aaa = "https://hd-sit1.test.hihonor.com/mobileZuul/integration/spuImage/miniTxtLoad?url=marking/upload/2024-12-25/eb2f87a483ab45dbab75bebe44fbd562.txt";
      try {
        const url = `${config.hdBaseUrl}/mobileZuul/integration/spuImage/miniTxtLoad?url=${ruleDescriUrl}`;
        // 使用 fetch API 下载文件
        const response = await fetch(url);
        // 检查响应是否成功
        if (response.status === 200) {
          // 读取文件内容
          const text = await response.text();
          try {
            const obj = JSON.parse(text);
            if (obj && obj.code == 500 && obj.message) {
              // 请求成功了但没有返回结果
              this.ruleDesc = '';
            } else {
              this.ruleDesc = text;
            }
          } catch (err) {
            this.ruleDesc = text;
          }
          this.ruleDesc = this.ruleDesc.replace(/accountzuul/g, 'mobileZuul');
          this.ruleDesc = this.ruleDesc.replace(/ihlp/g, 'hd');
          console.log('下载和读取规则成功:', text);
        } else {
          this.ruleDesc = '';
        }
      } catch (error) {
        this.ruleDesc = '';
        console.log('下载或读取规则出错:', error);
      }
    },
    getRules() {
      this.isShow = true;
      this.rePortRules();
    },
    // 根据 type 返回对应组件
    getComponent(item) {
      switch (item.type) {
        case this.COMPONENT_TYPE.LOGIN_COMPONENT:
          return 'LoginComponent';
        case this.COMPONENT_TYPE.TASK_COMPONENT:
          return 'TaskComponent';
        case this.COMPONENT_TYPE.IMAGE_COMPONENT:
          return 'ImagesComponent';
        default:
          return null;
      }
    },
    getActivityDetailData() {
      return new Promise((resolve) => {
        this.$api.post({
          sc: 'mobileMarketing',
          url: `/h5/activityTask/queryActivityDetail/${this.activityCode}`,
          success: (res) => {
            if (res.code && res.code === 200) {
              this.activityStatus = (res.result && res.result.activityStatus) || '';
              if (this.activityStatus !== ActivityStatus.running) {
                this.$refs.activityManagementRef.open();
              }
              this.activityStartTime = (res.result && res.result.activityStartTime) || '';
              this.activityEndTime = (res.result && res.result.activityEndTime) || '';
              if (res.result && res.result.ruleDescri) {
                this.downloadAndReadTextFile(res.result.ruleDescri);
              }
              const componentVOList = (res.result && res.result.componentVOList) || [];
              if (Array.isArray(componentVOList) && componentVOList.length > 0) {
                componentVOList.forEach((item) => {
                  item.jsonField = item.jsonField ? JSON.parse(item.jsonField) : {};
                  item.componentDetailVOlList = item.componentDetaiVOlList;
                  if (Array.isArray(item.componentDetailVOlList) && item.componentDetailVOlList.length > 0) {
                    item.componentDetailVOlList.forEach((ele) => {
                      ele.userTaskStatusIcon = '';
                      if (ele.userTaskStatus === this.TASK_STATUS.COMPLETED) {
                        ele.userTaskStatusIcon = this.IMAGE_SHOW_TYPE.COMPLETED;
                      } else if (ele.userTaskStatus === this.TASK_STATUS.NOT_STARTED) {
                        ele.userTaskStatusIcon = this.IMAGE_SHOW_TYPE.NOT_STARTED;
                      } else if (ele.userTaskStatus === this.TASK_STATUS.ENDED) {
                        ele.userTaskStatusIcon = this.IMAGE_SHOW_TYPE.ENDED;
                      }
                    });
                  }
                });
              }
              this.componentVOList = componentVOList;
            } else {
              Toast(res.message);
            }
            resolve(true);
          },
          failure: (err) => {
            resolve(err);
          },
        });
      });
    },

    rePortRules() {
      const params = {
        actionCode: '400070005',
        actionName: '点击活动规则',
        title: '点击活动规则',
      };
      this.goBatchReport(params);
    },
    goBatchReport(data) {
      const params = {
        actionCode: data.actionCode,
        actionName: data.actionName,
        content: {
          title: data.title,
          activityCode: this.activityCode,
        },
      };
      console.log('上报参数', params);
      utils.handleBatchReport(this, params);
    },
  },
};
</script>

<style lang="scss" scoped>
.rules-image {
  width: 100%;
  height: 100%;
}
.component-rules {
  position: fixed;
  top: 86px;
  right: 0px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 26px;
  font-size: 14px;
}
.rules {
  position: absolute;
  right: 9px;
}
.popup {
  overflow: inherit;
  background: transparent;
}
.popup-all {
  height: 600px;
  width: 296px;
  padding: 20px 24px;
  border-radius: 20px;
  background: #ffffff;
}
.popup-rules {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: normal;
  color: #3d3d3d;
  margin-bottom: 20px;
}
.popup-content {
  font-size: 14px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 14px;
  overflow-y: auto;
  overflow-x: hidden;
  height: 522px;
}
.close-image {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 23px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(470%, -2362%);
  image {
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="scss">
.popup-content {
  img {
    width: 100%;
  }
  /* 隐藏滚动条但仍可滚动 */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activityManagement.vue